<template>
	<header>
		<section class="wrapper">
			<div class="pd-t-20 pd-b-20 pd-l-20 pd-r-20 dp-fx fx-al-ct fx-js-bw cl-black-russian fz-14">
				<router-link to="/">
					<div class="dp-fx fx-al-ct">
						<img height="32" src="../assets/logo.png" alt="Nepometer Logo"/>
					</div>
				</router-link>
				<div class="fz-14 dp-fx fx-al-ct">
					<router-link v-if="currentUser" to="/logout">
						<img v-if="currentUser.photoURL" :src="currentUser.photoURL" :alt="currentUser.displayName" class="user-img">
						<img v-else src="https://o.cdn.newsbytesapp.com/assets/people/na.2.jpg" :alt="currentUser.displayName" class="user-img">
					</router-link>
					<router-link v-else to="/login" class="pd-t-4 pd-b-4 pd-l-8 pd-r-8">Login</router-link>
					<SearchModule/>
					<router-link to="/about" class="pd-t-4 pd-b-4 pd-l-8 pd-r-8 mg-l-10 cl-blue">
						<img src="@/assets/about.png" height=18 alt="About Icon"/>
					</router-link>
				</div>
			</div>
		</section>
	</header>
</template>

<style>
	.user-img{
		width: 40px;
		height: 40px;
		border-radius: 50%;
	}	
</style>

<script>
	import 	{ mapState } from "vuex";
	import SearchModule from "@/components/SearchModule.vue";
	const fb = require('../firebaseConfig.js');

	export default {
		name: "Navigation",
		components : {
			SearchModule : SearchModule
		},
		computed: {
			...mapState(['currentUser'])
		}
	};
</script>